import { render, staticRenderFns } from "./ResidenceListEmpty.vue?vue&type=template&id=b4e06ece&"
import script from "./ResidenceListEmpty.vue?vue&type=script&lang=js&"
export * from "./ResidenceListEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e06ece')) {
      api.createRecord('b4e06ece', component.options)
    } else {
      api.reload('b4e06ece', component.options)
    }
    module.hot.accept("./ResidenceListEmpty.vue?vue&type=template&id=b4e06ece&", function () {
      api.rerender('b4e06ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceListEmpty.vue"
export default component.exports